import { render, staticRenderFns } from "./ClientServerInfo.vue?vue&type=template&id=4a99eb3c&scoped=true&"
import script from "./ClientServerInfo.vue?vue&type=script&lang=js&"
export * from "./ClientServerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientServerInfo.vue?vue&type=style&index=0&id=4a99eb3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99eb3c",
  null
  
)

export default component.exports